<template>
  <div>
      <main-header></main-header>
      <div class="pagebanner1" :style="{background:'url('+ banner.img +') center 0 no-repeat'}">
        <div>{{banner.title}}</div>
      </div>
      <div class="aboutus">
        <div class="w1200 aboutusbox">
          <div class="cont">
            <h1>{{about.title}}</h1>
            <span v-html="about.content"></span>
          </div>
          <div class="pic">
            <img :src="about.img" alt="">
          </div>
        </div>
      </div>
      <div class="servicetype">
        <div class="w1200">
          <div class="title">
            <h1>{{servicetype.title}}</h1>
            <span>
                {{servicetype.subtitle}}
            </span>
          </div>
          <ul class="serveceilist">
            <li v-for="(service,index) in services" :key="index" class="flipInX wow" data-wow-duration="1.3s" :data-wow-delay="0.5*index+'s'" >
              <div class="picbox">
                <img :src="service.image" alt="">
              </div>
              <div class="cont">
                <h1>{{service.title}}</h1>
                <span>{{service.describe}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
import {WOW} from 'wowjs'
export default {
  name: 'about',
  data () {
    return {
      banner: {
        img: '',
        title: ''
      },
      about: {
        img: '',
        title: '',
        content: ''
      },
      servicetype: {
        title: '',
        subtitle: ''
      },
      services: []
    }
  },
  methods: {
  },
  components: {
    MainHeader
  },
  beforeCreate () {
    const that = this
    Fetch.post('Api/serve', {
    }).then((res) => {
      that.banner.img = res.serve.banner
      that.banner.title = res.serve.sub_title
      that.about.img = res.serve.image
      that.about.title = res.serve.title
      that.about.content = res.serve.content
      that.servicetype.title = res.serve.service_title
      that.servicetype.subtitle = res.serve.describe
      that.services = res.service
      setTimeout(function () {
        var wow = new WOW({live: false})
        wow.init()
      }, 100)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebanner1{height: 400px;overflow: hidden;display: flex;align-items: center;justify-content: center;font-size: 40px;color: #fff;}
  .aboutus{height: auto;padding: 100px 0;background-color: #fff;}
  .aboutusbox{display: flex;justify-content: space-between;}
  .aboutus .pic{width: 450px;height: 280px;}
  .aboutus .pic img{width: 450px;height:280px;object-fit:cover;}
  .aboutus .cont{width: 670px;height: auto;overflow: hidden;}
  .aboutus .cont h1{display: block;line-height: 60px;height: 60px;margin-bottom: 25px;font-size: 40px;}
  .aboutus .cont span{display: block;line-height: 40px;font-size: 16px;line-height: 40px;color: #333;}
  .servicetype{height: auto;overflow: hidden;margin-top: 20px;margin-bottom: 20px;}
  .servicetype .title h1{width: 100%;height: 60px;line-height: 60px;font-size: 40px;}
  .servicetype .title span{width: 100%;line-height: 30px;font-size: 16px;}
  .serveceilist{width: 100%;height: auto;overflow: hidden;margin-top: 30px;}
  .serveceilist li{width: 100%;height: auto;margin-bottom: 30px; cursor:pointer;box-sizing: border-box;border: 1px solid #f6f6f6;display: flex;justify-content: space-between;}
  .serveceilist li .picbox{width: 390px;overflow: hidden;margin-left: 10px;margin-top:10px ;margin-bottom:10px;}
  .serveceilist li:hover{box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);}
  .serveceilist li img{width: 390px;height: 100%;object-fit:cover;transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
  .serveceilist li:hover img{transform: scale(1.2);}
  .serveceilist li .cont{flex: 1;margin-left: 25px;margin-right: 25px;}
  .serveceilist li .cont h1{display: block;width: 100%;height: 30px;line-height: 30px;margin-top: 10px;font-size: 25px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;}
  .serveceilist li .cont span{display: block;width: 100%;font-size: 15px;margin-top: 7px;line-height: 30px;}
</style>



// WEBPACK FOOTER //
// src/page/service.vue